import React, { useRef } from 'react';
import { ChevronLeft, ChevronRight, ArrowUpRight } from 'lucide-react';
import { projects } from '../mock';

export default function OurWork() {
  const scroller = useRef(null);
  const scroll = (dir) => {
    if (scroller.current) scroller.current.scrollBy({ left: dir * 380, behavior: 'smooth' });
  };

  return (
    <section id="work" className="py-12 lg:py-24 overflow-hidden bg-wash">
      <div className="section-pad max-w-[1440px] mx-auto">
        <div className="flex items-end justify-between flex-wrap gap-4 mb-8 sm:mb-12">
          <div>
            <span className="eyebrow"><span className="dot" /> Our Work</span>
            <h2 className="font-display mt-4 sm:mt-6 text-3xl sm:text-4xl md:text-5xl lg:text-[3.4rem] font-extrabold leading-[1.05] tracking-tight max-w-2xl">
              Recent projects. <span className="font-serif italic font-normal text-accent-orange">Real results.</span>
            </h2>
            <p className="mt-4 text-[#5a5548] max-w-xl">Explore selected PPF, protection, detailing and styling work completed by VINYLED in Bengaluru.</p>
          </div>
          <div className="flex gap-2 sm:gap-3">
            <button onClick={() => scroll(-1)} className="w-10 h-10 sm:w-12 sm:h-12 rounded-full border border-black/12 bg-white flex items-center justify-center text-[#16150f] hover:bg-[#16150f] hover:text-white transition-all"><ChevronLeft className="w-5 h-5" /></button>
            <button onClick={() => scroll(1)} className="w-10 h-10 sm:w-12 sm:h-12 rounded-full border border-black/12 bg-white flex items-center justify-center text-[#16150f] hover:bg-[#ff5a1f] hover:text-white hover:border-[#ff5a1f] transition-all"><ChevronRight className="w-5 h-5" /></button>
          </div>
        </div>
      </div>

      <div ref={scroller} className="flex gap-5 overflow-x-auto no-scrollbar section-pad max-w-[1440px] mx-auto pb-4 snap-x">
        {projects.map((p, i) => (
          <a key={i} href="#contact" className="group relative shrink-0 w-[78vw] max-w-[300px] sm:w-[320px] h-[360px] sm:h-[440px] rounded-[1.4rem] overflow-hidden card-elevated snap-start">
            <img src={p.img} alt={p.title} className="absolute inset-0 w-full h-full object-cover group-hover:scale-110 transition-transform duration-700" />
            <div className="absolute inset-0 bg-gradient-to-t from-black/75 via-black/5 to-transparent" />
            <span className="absolute top-4 left-4 text-[0.6rem] font-semibold tracking-widest text-[#16150f] bg-white/90 backdrop-blur px-2.5 py-1 rounded-full">{p.cat}</span>
            <div className="absolute bottom-5 left-5 right-5 flex items-end justify-between">
              <div>
                <h3 className="font-display text-xl font-bold text-white">{p.title}</h3>
                <p className="text-xs text-white/80 mt-1">{p.sub}</p>
              </div>
              <span className="w-10 h-10 rounded-full bg-white/95 flex items-center justify-center text-[#16150f] group-hover:bg-[#ff5a1f] group-hover:text-white transition-all duration-300">
                <ArrowUpRight className="w-4 h-4" />
              </span>
            </div>
          </a>
        ))}
      </div>
    </section>
  );
}
